<template>
  <stage-card
    :progress="progress"
    progress-pending-label="Awaiting Included References"
  >
    <template #header>Data Extraction</template>
    <template #content>
      <div>
        <stage-card-progress-bar
          title="Extracted"
          success-tooltip-prefix="Extracted:"
          :success-count="extracted"
          light-success-tooltip-prefix="Partially Extracted:"
          :light-success-count="partiallyExtracted"
          error-tooltip-prefix="Awaiting Consensus Review:"
          :error-count="conflicted"
          other-tooltip-prefix="Need extraction:"
          :total-count="total"
        />
      </div>
      <div>
        <data-extraction-remaining-tasks-list
          :progress-summary="progressSummary"
        />
      </div>
    </template>
    <template #actions>
      <action-button color="primary" @click="$emit('open-workflow')">
        {{ openWorkflowLabel }}
      </action-button>
    </template>
  </stage-card>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import StageCard from './StageCard';
import StageCardProgressBar from './StageCardProgressBar';
import DataExtractionRemainingTasksList from './DataExtractionRemainingTasksList';
import { Review } from '@/models';
import { StageCardProgress } from '@/enums';

export default {
  name: 'DataExtractionStageCard',
  components: {
    ActionButton,
    StageCard,
    StageCardProgressBar,
    DataExtractionRemainingTasksList,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  emits: ['open-workflow'],
  computed: {
    progress() {
      if (this.review.isDataExtractionComplete()) {
        return StageCardProgress.COMPLETE;
      }
      if (this.progressSummary.totalReferenceCount() === 0) {
        return StageCardProgress.PENDING;
      }
      return StageCardProgress.IN_PROGRESS;
    },
    progressSummary() {
      return this.review.dataExtractionProgressSummary;
    },
    extracted() {
      return this.progressSummary.extractedCount;
    },
    partiallyExtracted() {
      return this.progressSummary.partiallyExtractedCount;
    },
    conflicted() {
      return this.progressSummary.conflictedExtractionCount;
    },
    total() {
      return this.progressSummary.totalReferenceCount();
    },
    openWorkflowLabel() {
      if (this.progress === StageCardProgress.COMPLETE) {
        return 'View Outcomes';
      }
      return 'Extract References';
    },
  },
};
</script>
